import { urlBuilder } from './builder';

export default urlBuilder(() => '/activity/');
